import request from '@/utils/request'
// 小编推荐
export function comic_recommend(data) {
    return request({
        url: 'api/comic/recommend',
        method: 'post',
        params: data
    })
}
// 最近更新
export function comic_updated(data) {
    return request({
        url: 'api/comic/update',
        method: 'post',
        params: data
    })
}
//本月精华
export function comic_popular(data) {
    return request({
        url: 'api/comic/popular',
        method: 'post',
        params: data
    })
}
//动漫分类
export function comic_index(data) {
    return request({
        url: 'api/comic/index',
        method: 'post',
        params: data
    })
}
// 动漫详情
export function comic_detail(data) {
    return request({
        url: 'api/comic/detail',
        method: 'post',
        params: data
    })
}
//动漫目录
export function comic_lists(data) {
    return request({
        url: 'api/comic/lists',
        method: 'post',
        params: data
    })
}
//观看漫画
export function comic_watch(data) {
    return request({
        url: 'api/comic/watch',
        method: 'post',
        params: data
    })
}
//观看到第几话
export function comic_history_num(data) {
    return request({
        url: 'api/comic/history_num',
        method: 'post',
        params: data
    })
}
//漫画续看
export function comic_comic_history(data) {
    return request({
        url: 'api/comic/comic_history',
        method: 'post',
        params: data
    })
}


// WEBPACK FOOTER //
// ./src/api/comic.js